import PropTypes from 'prop-types';
import React from 'react';
import Modal from 'react-overlays/Modal';
import { isMobileSafari } from 'react-device-detect';
import Transition, { ENTERED, ENTERING } from 'react-transition-group/Transition';
import classNames from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles'
import Default, { Mobile } from '../../../utils/mediaQueries';
import { colorGrayLight, colorGrayLight2 } from '../../../utils/variables.scss';
import { withRtl } from '../../../components/hoc';

import style from './ScheduleModal.scss';

const fadeStyles = {
  [ENTERING]: style.scheduleModalIn,
  [ENTERED]: style.scheduleModalIn,
};

const ScrollIn = ({ className, children, ...props }) => (
  <Transition {...props} timeout={300}>
    {(status, innerProps) =>
      React.cloneElement(children, {
        ...innerProps,
        className: classNames(
          style.scheduleModalDefault,
          className,
          children.props.className,
          fadeStyles[status],
        ),
      })
    }
  </Transition>
);

ScrollIn.defaultProps = {
  children: false,
  className: '',
};

ScrollIn.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]),
};

const dialogStyle = () => {
  const screenWidth = window.innerWidth;
  const modalWidth = Math.min(750, screenWidth * 0.95); // Max 750px or 95% of screen width
  const leftPosition = (screenWidth - modalWidth) / 2;

  return {
    position: 'absolute',
    maxWidth: '750px',
    width: '95%',
    left: `${leftPosition}px`,
    top: '16%',
    border: `1px solid ${colorGrayLight2}`,
    backgroundColor: 'white',
    boxShadow: `0 5px 15px rgba(0, 0, 0, .5)`,
    padding: 20,
    borderRadius: '5px',
    overflowY: 'auto',
    overflowX: 'hidden',
    maxHeight: '95vh',
  };
};


const mobileDialogStyle = () => {
  const screenWidth = window.innerWidth;
  const modalWidth = Math.min(750, screenWidth * 0.95);
  const leftPosition = (screenWidth - modalWidth) / 2;

  return {
    position: 'absolute',
    maxWidth: '750px',
    width: '95%',
    left: `${leftPosition}px`,
    top: '16%',
    border: `1px solid ${colorGrayLight2}`,
    backgroundColor: 'white',
    boxShadow: `0 5px 15px rgba(0, 0, 0, .5)`,
    padding: 20,
    borderRadius: '5px',
    overflowY: 'auto',
    overflowX: 'hidden',
    maxHeight: '95vh',
  };
};

const modalStyle = {
  position: 'fixed',
  zIndex: 1040,
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  overflow: 'scroll',
};

const backdropStyle = {
  ...modalStyle,
  zIndex: 'auto',
  backgroundColor: colorGrayLight,
  opacity: 0.85,
};

class ScheduleModal extends React.PureComponent {
  close = () => {
    console.log('State', this.state)
    this.props.close();
  };

  afterClose = () => {
    this.props.afterClose();
  };

  handleEntered = () => {
    this.props.focusModal();
  };

  render() {
    const { children, show, isRtl, ariaLabel, containerRef } = this.props;

    return (
      <div aria-live={show ? 'assertive' : 'off'}>
        <Default>
          <Modal
            backdrop={'static'}
            keyboard={false}
            aria-label={ariaLabel}
            show={show}
            onHide={this.close}
            onExited={this.afterClose}
            style={modalStyle}
            backdropStyle={backdropStyle}
            // backdropTransition={ScrollIn}
            // transition={ScrollIn}
            // container={document.body}
            onEntered={this.handleEntered}
          >
            <div className={isRtl ? style.rtl : null} style={dialogStyle()}>
              <button
                aria-label="Close button"
                className={classNames('button--no-style', style.scheduleModalClose)}
                onClick={this.close}
                ref={containerRef}
              >
                <i className="icon-Remove" />
              </button>
              {children}
            </div>
          </Modal>
        </Default>
        <Mobile>
          <Modal
            aria-label={ariaLabel}
            show={show}
            onHide={this.close}
            onExited={this.afterClose}
            style={modalStyle}
            backdropStyle={backdropStyle}
            // container={this}
            onEntered={this.handleEntered}
            // backdropTransition={ScrollIn}
            // transition={ScrollIn}
            backdrop={'static'}
            keyboard={false}
          >
            <div className={isRtl ? style.rtl : null} style={mobileDialogStyle()}>
              <button
                aria-label="Close button"
                className={classNames('button--no-style', style.scheduleModalClose)}
                onClick={this.close}
                ref={containerRef}
              >
                <i className="icon-Remove" />
              </button>
              {children}
            </div>
          </Modal>
        </Mobile>
      </div>
    );
  }
}

ScheduleModal.defaultProps = {
  isRtl: false,
  children: false,
  ariaLabel: '',
  containerRef: null,
};

ScheduleModal.propTypes = {
  show: PropTypes.bool.isRequired,
  isRtl: PropTypes.bool,
  close: PropTypes.func.isRequired,
  afterClose: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]),
  ariaLabel: PropTypes.string,
  containerRef: PropTypes.shape({}),
  focusModal: PropTypes.func.isRequired,
};

export default withRtl(style)(withStyles(style)(ScheduleModal));
